import React from 'react';
import StageBackground from '../../DeviationBackground/StageBackground';
import DeviationFullView from '../../DeviationViews/Full';
import DuperbrowsePaddles from '../../Duperbrowse/DuperbrowsePaddles';
import s from './CommissionStage.scss';
const CommissionStage = ({ deviation })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(StageBackground, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(DeviationFullView, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(DuperbrowsePaddles, {
        className: s['duperbrowse']
    }));
};
CommissionStage.displayName = 'CommissionStage';
export default CommissionStage;

//# sourceMappingURL=CommissionStage.js.map